"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyUnblindRequestType = void 0;
var StudyUnblindRequestType;
(function (StudyUnblindRequestType) {
    StudyUnblindRequestType["ApprovalRequired"] = "APPROVAL_REQUIRED";
    StudyUnblindRequestType["UnderConditionsWithoutApproval"] = "UNDER_CONDITIONS_WITHOUT_APPROVAL";
    StudyUnblindRequestType["WithoutApproval"] = "WITHOUT_APPROVAL";
})(StudyUnblindRequestType = exports.StudyUnblindRequestType || (exports.StudyUnblindRequestType = {}));
//# sourceMappingURL=crf.js.map